import React from "react";
import useTestSeries from "./useTestSeries";
import TestSeries from "./Components/TestSeries";

const TestSeriesIndex: React.FC = () => {

  return <TestSeries />;
};
export default TestSeriesIndex;
